// Banner'ın hangi vitrine düştüğü tek yerden okunur.
//
// `/sliders` yanıtı **bütün** banner'ları döndürür; hangisinin nerede
// çizileceğini `placement` söyler (backend: `models.SliderPlacement`). Süzgeç
// kabuk başına kopyalandığı için bir süre yalnızca klasik ana sayfa ile
// HeroSlider süzüyordu; Merit/Zümrüt/Paris/Vega/Herkül kabukları listeyi
// olduğu gibi çizdiği için "Yan Banner" olarak işaretlenen görsel o
// şemalarda ana slider'a da düşüyordu. Katalog sayfası banner'ları
// eklendiğinde aynı sızıntı slot banner'ını beş ana sayfaya taşırdı — bu
// yüzden süzgeç artık ortak.
//
// İlgili: components/PageSlider.jsx, components/HeroSlider.jsx.

export const DEFAULT_PLACEMENT = 'main';

// Kolonun varsayılanı 'main'; alanı hiç yazılmamış eski kayıtlar da ana
// slider'a aittir.
export const placementOf = (slide) => (
  (slide && slide.placement) || DEFAULT_PLACEMENT
);

// CMS bannerları platform (web/mobil) ve kitle (üye/ziyaretçi) taşır.
// Oturum durumu AuthContext tarafından buraya yazılır; süzgeç saf kalır ve
// kabuklar çağrılarını değiştirmez.
let viewer = { loggedIn: false };
export const setBannerViewer = (next) => { viewer = { loggedIn: Boolean(next?.loggedIn) }; };

const viewportIsMobile = () => {
  try { return typeof window !== 'undefined' && Boolean(window.matchMedia?.('(max-width: 1023px)').matches); } catch { return false; }
};

export const bannerVisible = (slide, { mobile = viewportIsMobile(), loggedIn = viewer.loggedIn } = {}) => {
  const platforms = Array.isArray(slide?.platform) && slide.platform.length ? slide.platform : ['web', 'mobile'];
  if (!platforms.includes(mobile ? 'mobile' : 'web')) return false;
  if (slide?.show_for === 'logged_in' && !loggedIn) return false;
  if (slide?.show_for === 'logged_out' && loggedIn) return false;
  return true;
};

// CMS › Bloklar: "Ana sayfa mobil Orta Banner" mobilde ana slider'ın yerini
// alır; grup boşsa mobilde de web bannerları ("Ana sayfa Web Orta Banner")
// çizilir — telefonda slider hiç kaybolmaz.
export const MOBILE_MAIN_PLACEMENT = 'main-mobile';

export const slidersAt = (slides, placement = DEFAULT_PLACEMENT, context) => {
  const list = Array.isArray(slides) ? slides : [];
  const pick = (key) => list.filter((slide) => placementOf(slide) === key && bannerVisible(slide, context));
  if (placement === DEFAULT_PLACEMENT && (context?.mobile ?? viewportIsMobile())) {
    const mobile = pick(MOBILE_MAIN_PLACEMENT);
    if (mobile.length) return mobile;
  }
  return pick(placement);
};

/**
 * Ana sayfa oyun şeritleri (Bloklar › "… Canlı Casino / Mini Games / Slot
 * Oyunları"): her banner bir oyundur. `kind`: 'live' | 'mini' | 'slots'.
 * Web ve mobil ayrı gruptur; görsel bannerın kendisi, yoksa oyunun görseli.
 */
export const blockGames = (slides, kind, context) => {
  const mobile = context?.mobile ?? viewportIsMobile();
  const key = `${mobile ? 'home-mobile' : 'home-web'}-${kind}`;
  return slidersAt(slides, key, { ...context, mobile })
    .filter((slide) => slide.game && slide.game.id)
    .map((slide) => ({ ...slide.game, image: slide.image || slide.game.image, name: slide.title || slide.game.name }));
};

export default slidersAt;
